import { layers } from 'app/spacing';
import styled from '@emotion/styled';
import { Gradient as BaseGradient } from '__components/Kizen/ScrollFadeContainer';
import { STEP_CARD_PADDING } from '../../constants';
import css from '@emotion/css';
import { SemanticColorName } from '@kizen/kds/Colors';

const HISTORY_HEIGHT = 56;
const HISTORY_WRAPPER_HEIGHT = HISTORY_HEIGHT * 2 + STEP_CARD_PADDING;
const DEBUGGER_CONTROLS_HEIGHT = 14;

export const StyledHistoryPanel = styled.div<{
  showControls: boolean;
  marginRight?: string;
}>`
  overflow-y: auto;
  max-height: ${({ showControls }) =>
    showControls
      ? HISTORY_WRAPPER_HEIGHT - (STEP_CARD_PADDING + DEBUGGER_CONTROLS_HEIGHT)
      : HISTORY_WRAPPER_HEIGHT}px;
  min-height: ${HISTORY_HEIGHT}px;
  margin-right: ${({ marginRight }) => marginRight};
  position: relative;
`;

export const StyledHistoryDetailsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${STEP_CARD_PADDING}px;
`;

export const StyledTopGradient = styled((props) => (
  <BaseGradient fadeStart={0} fadeLength={18} {...props} />
))`
  z-index: ${layers.content(0, 1)};
  top: -2px;
`;

export const StyledBottomGradient = styled((props) => (
  <BaseGradient fadeStart={0} fadeLength={18} {...props} />
))`
  z-index: ${layers.content(0, 1)};
  bottom: -2px;
`;

export const StyledControlWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  > div {
    display: flex;
    column-gap: 10px;
  }
  height: ${DEBUGGER_CONTROLS_HEIGHT}px;
`;

export const StyledHistoryDetails = styled.div<{
  focusedStep: boolean;
}>`
  height: ${HISTORY_HEIGHT}px;
  position: relative;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${({ focusedStep }) =>
    focusedStep
      ? css`
          background-color: var(--color-background-light);
        `
      : css`
          background-color: var(--color-background-lightest);
          cursor: pointer;
          &:hover {
            background-color: var(--color-background-lighter);
          }
          &:active {
            background-color: var(--color-background-light);
          }
        `};
`;

export const StyledHistoryDetailsLabel = styled.span<{
  color?: SemanticColorName;
  clickable?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: fit-content;
  gap: 5px;
  ${({ color, clickable }) =>
    clickable &&
    css`
      cursor: pointer;
      &:hover {
        text-decoration: underline;
        text-decoration-color: var(--color-${color});
      }
    `}
`;
